<template>
    <div style="width: 100%;">
      <div class="dx_product-top">
            <div class="dx_product-image__gallery">
                <div class="dx_product-icons">
                    <img loading="lazy" class="dc-bar" v-if="product.price_tag === 'deal'" v-bind:src="assetUrl('images/product/dealBar.svg')">
                    <img loading="lazy" class="dc-bar" v-if="product.price_tag === 'sale'" v-bind:src="assetUrl('images/product/saleBar.svg')">
                    <img loading="lazy" class="dc-bar" v-if="product.price_tag === 'new'" v-bind:src="assetUrl('images/product/newBar.svg')">
                    <img loading="lazy" v-if="product.is_sulfate_free"
                         v-bind:src="assetUrl('images/product/sulfateFree.svg')">
                    <img loading="lazy" v-if="product.is_paraben_free"
                         v-bind:src="assetUrl('images/product/parabenFree.svg')">
                    <img loading="lazy" v-if="product.is_lilial_free"
                         v-bind:src="assetUrl('images/product/lilial_free.svg')">
                    <img loading="lazy" v-if="product.is_vegan" v-bind:src="assetUrl('images/product/vegan.svg')">
                    <img loading="lazy" v-if="product.is_curly_girl"
                         v-bind:src="assetUrl('images/product/curlyGirl.svg')">
                    <img loading="lazy" v-if="product.is_cruelty_free"
                         v-bind:src="assetUrl('images/product/crueltyFree.svg')">
                  <img loading="lazy" v-if="product.is_new_look"
                       v-bind:src="assetUrl('images/product/newLook.svg')">
                </div>

                <button :class="wishlistClass" class="rs-add-to-wishlist" :data-object="product.data_object" :data-id="product.id" type="button" id="wishlist_button"
                        v-on:click="toggleWishlist" v-if="product.show_wishlist_button">
                    <span class="c-icon">
                        <span class="empty" v-html="icons['heart-empty']"></span>
                        <span class="full" v-html="icons['heart-full']"></span>
                    </span>
                </button>
                <MainMedia/>
            </div>
            <div class="dx_product-variants">
                <ProductsSelect/>

                <div class="dx_usps">
                    <div v-for="usp in uspsByArticle" v-bind:key="usp.text" class="dx_usps__usp">
                        <div class="dx_usps__usp__icon" v-html="icons[usp.icon]"></div>
                        <span v-html="usp.text"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MainMedia from "@/components/MainMedia";
import ProductsSelect from "@/components/ProductsSelect";

export default {
    name: 'App',
    components: {ProductsSelect, MainMedia},
    data() {
        return {}
    },
    created() {
        var dataset = document.querySelector('#dx_product-page').dataset;

        this.$store.commit('storeIcons', JSON.parse(dataset.icons.replaceAll('&#039;', "'")));
        this.$store.commit('storeWishlist', JSON.parse(dataset.wishlist.replaceAll('&#039;', "'")));
        this.$store.commit('storeVariationGroup', JSON.parse(dataset.variationgroup.replaceAll('&#039;', "'")));
        this.$store.commit('storeAssetUrl', dataset.asseturl.replaceAll('&#039;', "'"));
        this.$store.commit('storePromotionTrigger', JSON.parse(dataset.promotiontrigger.replaceAll('&#039;', "'")));
        this.$store.commit('storeCurrency', JSON.parse(dataset.currency.replaceAll('&#039;', "'")));
        this.$store.commit('storeShop', JSON.parse(dataset.shop.replaceAll('&#039;', "'")));
        this.$store.commit('storeTranslations', JSON.parse(dataset.translations.replaceAll('&#039;', "'")));
        this.$store.commit('storeUsps', JSON.parse(dataset.usps.replaceAll('&#039;', "'")));
        this.$store.commit('setActiveProduct', JSON.parse(dataset.product.replaceAll('&#039;', "'")));
    },
    computed: {
        product() {
            return this.$store.getters.activeProduct
        },
        usps() {
            return this.$store.getters.usps
        },
        uspsByArticle() {
            let usps = this.$store.getters.usps;

            if (this.product.has_stock) {
                return usps;
            }

            return usps.filter(function (i) {
                return i.icon !== 'clock';
            });
        },
        translations() {
            return this.$store.getters.trans;
        },
        icons() {
            return this.$store.getters.icons;
        },
        productMedia() {
            return this.$store.getters.productMedia
        },
        ratingWidth() {
            return this.product.reviews.rating * 20 - 5.5 + '%';
        },
        starsHtml() {
            const s = this.icons.star;
            return s + s + s + s + s;
        },
        wishlistClass() {
            if (this.$store.getters.activeProduct.on_wishlist) {
                return 'j-btn-wishlist -wishlist-button-new j-listed'
            }
            return 'j-btn-wishlist -wishlist-button-new'
        }
    },
    methods: {
        toggleWishlist: function () {
            let wasOnWishlist = this.product.on_wishlist;

            let newValue = !wasOnWishlist;
            let self = this;
            this.product.on_wishlist = newValue;

            this.product.variants.forEach(function (item) {
                if (item.id === self.product.id) {
                    item.on_wishlist = newValue;
                }
            });

            if (this.product.on_wishlist) {
                window.wishlistRemarketingTag();
            }

            let url = this.product.on_wishlist ? this.wishlistAddUrl() : this.wishlistRemoveUrl();
            let counters = document.getElementsByClassName('wishlist-count');

            const request = new XMLHttpRequest();
            request.open('POST', url, true);
            request.setRequestHeader('Content-Type', 'application/json');

            request.onload = function () {
              if (!(request.status >= 200 && request.status < 400)) {
                console.log('error');
                return;
              }

              const data = JSON.parse(request.responseText);

              if (data.hasErrors) {
                console.log(data.msg);
                return;
              }

              const count = data.data.wishlist_product_count;

              for (let i = 0; i < counters.length; i++) {
                const counter = counters[i];
                counter.innerHTML = count;

                if (count > 0) {
                  counter.classList.remove('c-hidden');
                } else {
                  counter.classList.add('c-hidden');
                }
              }
            };

          request.send(JSON.stringify({productId: this.product.id}));
        },
        wishlistAddUrl() {
            return this.$store.getters.wishlist.add
        },
        wishlistRemoveUrl() {
            return this.$store.getters.wishlist.remove
        },
        assetUrl(path) {
            return this.$store.getters.assetUrl + path;
        }
    }
}
</script>

<style>
</style>
